import React from "react";
import Gradient from "rgt";

const AllDataHeader = (props) => {
  return (
    <>
      <div className="card card-bg head-line mb-2">
        <div className="text-light d-flex  p-2 align-items-center">
          <div className="ModuleLogo">
            {props.image ? (
              <img src={props.image} className="img-top" alt="..." />
            ) : (
              <div className="faTrophy">
                {props.icon === "true" ? (
                  <>
                  
                  <i class={props.iconP}></i></>
                ) : (
                  <i className="fas fa-trophy"></i>
                )}
              </div>
            )}

            {props.count === "Zero" ? null : (
              <>
                {props.count === 0 ? null : (
                  <small className="CountN text-center">{props.count}</small>
                )}
              </>
            )}
          </div>
          <h4 className="module-title mx-2">
            <Gradient dir="left-to-right" from="#FFAD00" to="#dfd400">
              <span className="Cap-t text-light fw-bold mx-2">
                {props.title}
              </span>
            </Gradient>
          </h4>
        </div>
      </div>
    </>
  );
};

export default AllDataHeader;
